export default "__VITE_PUBLIC_ASSET__4f03de99__"